// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/global.css
// module id = 685
// module chunks = 5